import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";

export class OnboardingSteps extends Component {
	
	state = {
        steps:[],            
	};

	componentDidMount() {         
        

        this.setState({ steps: [
            {"id":'1',"name":'Getting Started'},
            {"id":'2',"name":'Writing Jobs Info'},
			{ "id": '3', "name":'Select Plan'},
			{ "id": '4', "name":'Membership Info'}
		] }); 
    }
	
	render() {
		return (
            <Fragment>
			    <div className="steps h-100">
				    <img className="checkout-resp-logo mx-auto d-block mb-4 w-75" src="/images/logo_w.png"  width="161" height="34"  alt="pw-logo"/>
				    <ul>
					    {this.state.steps.map(
						(item, index) => {
							return (
					            <li key={index} className={`d-flex align-items-center py-md-3 px-md-0 px-4 ${this.props.show === item.id ? `active` : ``}`}><span className="mr-3">{item.id}</span><b>{item.name}</b></li>
						    );
						}
					)}	
					</ul>
				</div>
			</Fragment>
		);
	}	
}

OnboardingSteps.contextType = AppContext;
export default OnboardingSteps;	


// WEBPACK FOOTER //
// ./src/components/general/include/OnboardingSteps.js